























































import { defineComponent } from '@nuxtjs/composition-api'
import { PropType } from 'vue';
import { getIsBook } from '~/utils/solepro/products';
import { ProductForProductPageType } from '~/utils/types/solepro/Product';
import { productBuyCTATrack } from '~/helpers/trackings/24orepro/products';
import { getAsJSON } from '~/utils/solepro/CmsComponentAggregator';

export default defineComponent({
    props:{
        product:{
            type: Object as PropType<ProductForProductPageType>
        }
    },
    setup(props){
        const hasAddictionalProducts = props.product.additionalProducts && props.product.additionalProducts.length>0
        const hasSomeBuyable = props.product.additionalProducts && props.product.additionalProducts.length>0 
        && props.product.additionalProducts.some(p=>p.buyable);

        
        const ctas = props.product.area_cta;
        const ctasObj = !!ctas ? getAsJSON(ctas): null;
        return {
            ctasObj,
            isBook: getIsBook(props.product),
            hasAddictionalProducts,
            hasSomeBuyable
        }
    },
    data(){
        return {
            editorialStickyBtn: null
        }
    },
    methods:{
        async manageScroll(evt){
            evt.preventDefault();

            try {
                const id = evt.target.href.split('#')[1];
                document.getElementById(id).scrollIntoView();
                await productBuyCTATrack(this.product);
            } catch(e) {
                console.error(e);
            }
        },
        checkElements(){
            document.querySelectorAll('[id^=sticky__]').forEach(el=>{
                const id = el.id.split('__')[1];
                if(!document.getElementById(id)){
                    el.classList.add('hidden')
                }else{
                    el.classList.remove('hidden')
                }
            })
        }
       
    },
    mounted(){
        /** @TODO do this check on custom state change on specific components to keep always reactive this bar */
        this.checkElements()
        const interval = setInterval(()=>{
            this.checkElements()
        },200)
        setTimeout(()=>{
            clearInterval(interval)
        },10000)

        try{
            this.editorialStickyBtn = this.ctasObj.children[0].children[0].children.find(btn=>btn.cssClasses.includes('pdp-sticky')).DOMContent.children[0];
            
        }catch(e){
            console.error(e)
            /** no sticky b tn choosen from area_cta */
        }
    }
})
